import { render, staticRenderFns } from "./AnnotatedPathwayHierarchyWC.vue?vue&type=template&id=02ddae12&shadow"
import script from "./AnnotatedPathwayHierarchyWC.vue?vue&type=script&lang=js&shadow"
export * from "./AnnotatedPathwayHierarchyWC.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./AnnotatedPathwayHierarchyWC.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports